import { Layout } from "antd";
import { useTranslation } from "react-i18next";
import GooglePlayBadge from "assets/images/download-gplay.png";

const { Footer } = Layout;

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kledo.crm";

const FooterCRM = () => {
  const { t } = useTranslation();

  return (
    <Footer style={{ textAlign: "center" }} className=" w-full bg-white">
      <div className="flex justify-center mb-3">
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t("footer.get_it_on_google_play")}
        >
          <img
            src={GooglePlayBadge}
            alt={t("footer.get_it_on_google_play")}
            height={40}
            style={{ height: 40, width: "auto" }}
          />
        </a>
      </div>
      © {new Date().getFullYear()}{" "}
      <a
        href="https://crm.id/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary"
      >
        Kledo CRM
      </a>{" "}
      v{import.meta.env.PACKAGE_VERSION}{" "}
      <span className="whitespace-nowrap">All rights reserved</span>
    </Footer>
  );
};

export default FooterCRM;
